import { Store } from 'vuex';

export default (store: Store<any>) => {
    store.dispatch('data/country/startScheduledConfigCheck');
    // store.dispatch('data/news/startScheduledNewsFetch');
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/jobs/scheduledJobs.ts